/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParticipantUserClaimReadDto
 */
export interface ParticipantUserClaimReadDto {
    /**
     * 
     * @type {number}
     * @memberof ParticipantUserClaimReadDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ParticipantUserClaimReadDto
     */
    participantUserId: number;
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserClaimReadDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserClaimReadDto
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserClaimReadDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserClaimReadDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserClaimReadDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ParticipantUserClaimReadDto
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ParticipantUserClaimReadDto
     */
    validTo?: Date;
}

/**
 * Check if a given object implements the ParticipantUserClaimReadDto interface.
 */
export function instanceOfParticipantUserClaimReadDto(value: object): value is ParticipantUserClaimReadDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('participantUserId' in value) || value['participantUserId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ParticipantUserClaimReadDtoFromJSON(json: any): ParticipantUserClaimReadDto {
    return ParticipantUserClaimReadDtoFromJSONTyped(json, false);
}

export function ParticipantUserClaimReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantUserClaimReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'participantUserId': json['participantUserId'],
        'clientId': json['clientId'],
        'clientName': json['clientName'],
        'type': json['type'],
        'value': json['value'],
        'description': json['description'] == null ? undefined : json['description'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
    };
}

export function ParticipantUserClaimReadDtoToJSON(json: any): ParticipantUserClaimReadDto {
    return ParticipantUserClaimReadDtoToJSONTyped(json, false);
}

export function ParticipantUserClaimReadDtoToJSONTyped(value?: ParticipantUserClaimReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participantUserId': value['participantUserId'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'type': value['type'],
        'value': value['value'],
        'description': value['description'],
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
    };
}

